import { useQuestionnaireStep } from '../../../../wrappers/question_wrapper/step_context';

import React from 'react';
import QuestionWrapper from '../../ui/question_wrapper';
import QuestionSubheading from '../../ui/question_subheading';

import styles from './index.module.css';

const CheckIcon = () => (
  <svg className={styles.check} viewBox='0 0 12 12' fill='none' aria-hidden='true'>
    <path d='M2 6.5L4.75 9L10 3.5' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

const AcknowledgmentQuestion = ({
  heading,
  subHeading,
  body,
  confirmationLabel = 'Yes, I understand',
  checked = false,
  onCheckedChange,
  onSubmit,
  onBack,
  current,
  total,
  ariaLabel,
  submitDisabledWhenUnchecked = true,
  showNavButtons = true,
}) => {
  const step = useQuestionnaireStep();
  const resolvedCurrent = current ?? step.current;
  const resolvedTotal = total ?? step.total;
  const isDisabled = submitDisabledWhenUnchecked && !checked;
  const isChecked = Boolean(checked);

  const handleToggle = () => {
    if (typeof onCheckedChange === 'function') onCheckedChange(!isChecked);
  };

  return (
    <QuestionWrapper
      current={resolvedCurrent}
      total={resolvedTotal}
      onBack={onBack}
      onSubmit={onSubmit}
      isDisabled={isDisabled}
      showNavButtons={showNavButtons}
    >
      <h2 className={styles.heading}>{heading}</h2>
      {subHeading && <QuestionSubheading>{subHeading}</QuestionSubheading>}
      <div className={styles.cards}>
        <div className={styles.bodyCard}>
          <div className={styles.bodyText}>{body}</div>
        </div>
        <label className={isChecked ? `${styles.confirmCard} ${styles.checked}` : styles.confirmCard}>
          <input
            type='checkbox'
            className={styles.input}
            checked={isChecked}
            onChange={handleToggle}
            aria-label={ariaLabel || confirmationLabel}
          />
          <span className={styles.checkbox}>
            <CheckIcon />
          </span>
          <span className={styles.confirmText}>{confirmationLabel}</span>
        </label>
      </div>
    </QuestionWrapper>
  );
};

export default AcknowledgmentQuestion;
